module.exports = __webpack_public_path__ + "img/vertical_7_7_6000.d64ead60.png";